import React from "react";
import { Link, useNavigate } from "react-router-dom";
import Button from "../button";
import { useLayoutContext } from "../../layouts/general-layout"; // Import context
import { RouterConstant } from "../../routers/index";
import { LoginService } from "../../services/login/login.services";
import { useUserStore } from '../../utils/userStore';
import {warningIcon } from "../../assets/images/index";
import PasswordInput from "../password-input";
import "./login-form.scss";

interface LoginFormProps {
  email: string;
  setEmail: (email: string) => void;
  password: string;
  setPassword: (password: string) => void;
  errors: { email?: string; general?: string };
  setErrors: (errors: { email?: string; general?: string }) => void;
  handleLogin: (e: React.FormEvent) => void;
  isLoading?: boolean;
  sessionExpired?: boolean;
}

export default function Index({
  email,
  setEmail,
  password,
  setPassword,
  errors,
  setErrors,
  handleLogin,
  isLoading = false,
  sessionExpired = false,
}: LoginFormProps) {
  const { t } = useLayoutContext();
  const { ROUTERS_PATH } = RouterConstant;
  const loginService = new LoginService();
  const navigate = useNavigate();
  const { setUserInfo: setData } = useUserStore();
  const [isChecking, setIsChecking] = React.useState(false);

  const handleResetPassword = async () => {
    if (!email.trim()) {
      setErrors({ email: t('enterEmail') });
      return;
    }

    try {
      setIsChecking(true)
      await loginService.emailValidation(email, undefined, 'reset');
      setData({ email: email });
      navigate(ROUTERS_PATH.USERREGISTRATIONOTP, { state: { navigation_source: 'reset' } });
    } catch (err: any) {
      const errorCode = err.response?.data?.detail?.error_code;
      if (errorCode === 5) {
        setErrors({ email: t("emailNotExist") });
      } else {
        setErrors({ email: t("emailValidationFailed")});
      }
    } finally {
      setIsChecking(false)
    }
  };

  return (
    <form className="login-page-form" onSubmit={handleLogin}>
      <div className="login-page-form-fields">
        <div className={`form-field ${errors.email ? 'error' : ''}`}>
          <input
            type="email"
            placeholder={t("email")}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          {errors.email && (<p className="error-message"><img src={warningIcon} alt="" /> {errors.email}</p>)}
        </div>
        
        <PasswordInput
          value={password}
          onChange={setPassword}
          placeholder={t("password")}
        />
        {errors.general && (<p className="error-message"> {errors.general}</p>)}
        <div className="reset-link">
          <button type="button" className='reset-button' onClick={handleResetPassword}>{t("passwordReset")}</button>
        </div>
        {sessionExpired && (
          <p className="session-expired-error">{t("sessionExpiredError")}</p>
        )}
      </div>

      <div className="login-page-form-action">
        <p>
          {t("DontHaveAnAccount")} <Link to={ROUTERS_PATH.USERREGISTRATIONSTEP1}>{t("enrollment")}</Link>
        </p>
        <Button type="submit" text={t("entry")} color="blue" disabled={isLoading} loader={isLoading} />
      </div>
    </form>
  );
}
